import React from 'react';
import './App.css'
import { Route, Routes } from 'react-router-dom';
import NavbarComponent from './components/NavbarComponent';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import OffersPage from './pages/OffersPage';

function App() {
  return (
    <div>
      <NavbarComponent />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/offers" element={<OffersPage />} />
      </Routes>
    </div>
  );
}

export default App;
